import React from 'react';
import { LoadMore } from '../load-more/load-more';
export const LoadMoreStateSwitch = ({ onClick, text, className, state, dataHook, icon }) => {
    switch (state.type) {
        case 'HAS':
            return (React.createElement(LoadMore, { className: className, text: text, onClick: onClick, dataHook: dataHook, icon: icon }));
        case 'PENDING':
            return (React.createElement(LoadMore, { className: className, text: text, isPending: true, dataHook: dataHook, icon: icon }));
        default:
            return null;
    }
};
//# sourceMappingURL=load-more-state-switch.js.map